import i18n from '@/translations'

export const CHECKOUT_TEMPLATES = [
  'default',
  'farol',
  'meridiano',
  'agora',
  'insignia',
  'pulso',
  'prumo',
] as const

export type CheckoutTemplateId = (typeof CHECKOUT_TEMPLATES)[number]

export function isCheckoutTemplate(
  value: string | null | undefined,
): value is CheckoutTemplateId {
  return CHECKOUT_TEMPLATES.some((template) => template === value)
}

/**
 * Nome do template para exibição. Aceita qualquer valor vindo do histórico:
 * vazio/`none` vira "Sem template" e id que o painel não conhece sai capitalizado.
 */
export function checkoutTemplateLabel(template?: string | null): string {
  const id = template?.trim()

  if (!id || id === 'none') {
    return i18n.t('reports:template_none')
  }

  const key = `checkouts:template_${id}`

  if (i18n.exists(key)) {
    return i18n.t(key)
  }

  return id.charAt(0).toUpperCase() + id.slice(1)
}

export function formatCheckoutLabel(
  name: string,
  template?: string | null,
): string {
  if (!template?.trim()) {
    return name
  }

  return `${name} / ${checkoutTemplateLabel(template)}`
}

export async function fetchReportTemplateOptions(
  query?: string,
): Promise<Array<{ value: string; label: string }>> {
  const term = query?.trim().toLowerCase()
  const options = CHECKOUT_TEMPLATES.map((id) => ({
    value: id,
    label: checkoutTemplateLabel(id),
  }))

  if (!term) {
    return options
  }

  return options.filter((option) => option.label.toLowerCase().includes(term))
}
